// PFM activity keys — seeded by migration 20260910_032504.
// Kept in one module so every leaf component gates on the same constant.
export const RBAC_MEASURES = 'PFM_MEASURES';
export const RBAC_ASSIGNMENTS = 'PFM_ASSIGNMENTS';
export const RBAC_SUBMISSIONS = 'PFM_SUBMISSIONS';
export const RBAC_DASHBOARD = 'PFM_DASHBOARD';
export const RBAC_REPORTS = 'PFM_REPORTS';
